/* global Twine */

import * as Turbo from '@hotwired/turbo';
import { Application } from '@hotwired/stimulus';
import { start } from '@anycable/turbo-stream';

import cable from 'common/lib/AnyCable/cable';

window.Turbo = Turbo;
window.Stimulus = Application.start();

Turbo.session.drive = false;

// Custom Turbo Stream actions

// <turbo-stream
//   action="download"
//   download-url="..."
//   download-file-name="..."
//   download-delay-in-ms="..."
// ></turbo-stream>
Turbo.StreamActions.download = function turboStreamVisit() {
  const url = this.getAttribute('download-url');
  const fileName = this.getAttribute('download-file-name');
  const delayInMs = parseInt(this.getAttribute('download-delay-in-ms'), 10) || 1;

  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.setAttribute('download', fileName);
  anchor.style.display = 'none';
  document.body.appendChild(anchor);

  setTimeout(() => {
    anchor.click();
    document.body.removeChild(anchor);
  }, delayInMs);

  return true;
};

// <turbo-stream
//   action="visit"
//   visit-location="/some-resource/1234"
//   visit-frame="someFrameDomId"
//   visit-action="advance|replace"
// ></turbo-stream>
// This is similar to a `window.location = ...` call but invoked with a Turbo
// Stream action. This honors any turbo frame specified. Default action is
// "advance". If no location is given, `window.location`` is used; this has the
// effect of reloading the current location but Turbo-ified.
// See: https://turbo.hotwired.dev/reference/drive#turbo.visit
Turbo.StreamActions.visit = function turboStreamVisit() {
  const location = this.getAttribute('visit-location') || window.location.toString();
  Turbo.visit(location, {
    frame: this.getAttribute('visit-frame'),
    action: this.getAttribute('visit-action'),
  });
};

// <turbo-stream
//   action="setCookie"
//   cookie-name="my_cookie"
//   cookie-value="myvalue"
//   cookie-domain="example.com"
//   cookie-path="/"
//   cookie-max-age="31536000"
//   cookie-secure="{true|false}"
//   cookie-samesite="{lax|strict|none}"
// ></turbo-stream>
// Set a cookie value based on the given attributes. Name/value are required;
// all other attributes are optional.
Turbo.StreamActions.setCookie = function turboStreamSetCookie() {
  const name = this.getAttribute('cookie-name');
  const value = this.getAttribute('cookie-value');
  const domain = this.getAttribute('cookie-domain');
  const path = this.getAttribute('cookie-path') || '/';
  const maxAge = this.getAttribute('cookie-max-age');
  const secure = this.getAttribute('cookie-secure');
  const samesite = this.getAttribute('cookie-samesite');

  let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
  if (domain) {
    cookie += `; domain=${encodeURIComponent(domain)}`;
  }
  if (path) {
    cookie += `; path=${path}`;
  }
  if (maxAge) {
    cookie += `; max-age=${encodeURIComponent(maxAge)}`;
  }
  if (secure === 'true') {
    cookie += '; Secure';
  }
  if (samesite) {
    cookie += `; samesite=${encodeURIComponent(samesite)}`;
  }

  document.cookie = cookie;
};

// https://stackoverflow.com/a/75704489
// https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Multiple_identical_event_listeners
// > If the function or object is already in the list of event listeners for
//   this target, the function or object is not added a second time.
if (window.turboFrameMissingHandlerFn === undefined) {
  window.turboFrameMissingHandlerFn = (event) => {
    const {
      detail: { response, visit },
    } = event;
    event.preventDefault();

    visit(response.url);
  };
}
// https://stackoverflow.com/a/75704489
document.addEventListener('turbo:frame-missing', window.turboFrameMissingHandlerFn);

if (window.turboFrameRenderFn === undefined) {
  window.turboFrameRenderFn = (event) => {
    if (event.target.dataset.turboFrameEvalTwine === 'true') {
      const nodes = event.target.querySelectorAll('[eval]');
      if (nodes.length > 0) {
        nodes.forEach((node) => {
          Twine.bind(node);
        });
        Twine.refresh();
      }
    }
  };
}
// https://stackoverflow.com/a/75704489
document.addEventListener('turbo:frame-render', window.turboFrameRenderFn);

start(cable, {
  requestSocketIDHeader: true,
  tagName: 'turbo-cable-stream-source',
});
